export const SET_APP_GRADELIST = 'SET_APP_GRADELIST';
export const SET_APP_TOPCOURSELIST = 'SET_APP_TopCourseList';
export const SET_APP_DEPARMENTLIST = 'SET_APP_CENTERLIST';
